<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    @if (organizationId()) {

        <!-- Recipients -->
        <section class="mb-3">
            <ms-recipient-selector
                [organizationId]="organizationId()!"
                (selectionChanged)="onRecipientSelectionChanged($event)">
            </ms-recipient-selector>
        </section>

        <!-- Message -->
        <section class="mb-4">
            <ms-compose-step></ms-compose-step>
        </section>

        <!-- Attachments -->
        <section class="mb-4">
            <h5 class="mb-1">Attachments <span class="text-muted fw-normal">(optional)</span></h5>
            <p class="text-muted">Attach files from your Document Center, or upload new ones.</p>
            <ms-email-attachments
                [organizationId]="organizationId()!"
                (attachmentsChanged)="onAttachmentSelectionChanged($event)">
            </ms-email-attachments>
        </section>

        <!-- Send -->
        <div class="d-flex justify-content-end align-items-center gap-3 mt-4">
            @if (!hasRecipients()) {
                <span class="text-muted small">Select at least one recipient to send.</span>
            } @else if (isUploadingAttachments()) {
                <span class="text-muted small">Waiting for attachments to finish uploading…</span>
            }
            <button type="button" class="btn btn-primary"
                [disabled]="!hasRecipients() || isSending() || isUploadingAttachments()"
                (click)="attemptSend()">
                <fa-duotone-icon icon="paper-plane" class="me-2" />
                Send Email
            </button>
        </div>

    }
    <!-- No @else needed: organizationRequiredGuard redirects away before this page renders without an
         active organization, so the @if only guards the organizationId()! assertion below. -->

    <ms-confirmation-modal #sendConfirmationModal [modalId]="sendConfirmationModalId"
        confirmButtonText="Send" cancelButtonText="Cancel"
        [isSubmitting]="isSending()"
        (confirmed)="onSendConfirmed()" (cancelled)="onSendCancelled()" />

    <ms-info-modal #sendResultModal [modalId]="sendResultModalId" (onConfirm)="onResultAcknowledged()" />

    <ms-confirmation-modal #leaveConfirmationModal [modalId]="leaveConfirmationModalId"
        confirmButtonText="Leave" cancelButtonText="Stay"
        (confirmed)="onLeaveConfirmed()" (cancelled)="onLeaveCancelled()" />
</div>
